module.exports = __webpack_public_path__ + "img/image17.8a093841.png";